import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/HomePage";
import AboutPage from "../pages/AboutPage";
import ContactPage from "../pages/ContactPage";
import CareersPage from "../pages/CareersPage";
import CoursesPage from "../pages/CoursesPage";
import ApplyPage from "../pages/ApplyPage";

export const RootNavigation = () => {
  return (
    <>
      <Routes>
      <Route path="/" element={<HomePage />}></Route>
      <Route path="/about" element={<AboutPage />}></Route>
      <Route path="/contact" element={<ContactPage />}></Route>
      <Route path="/careers" element={<CareersPage />}></Route>
      <Route path="/courses" element={<CoursesPage />}></Route>
      <Route path="/apply" element={<ApplyPage />}></Route>




      

      </Routes>
    </>
  );
};
